import scpi from './scpi';
import dismemberedScpi from './dismemberedScpi';
import lifeInsurance from './lifeInsurance';
import pinel from './pinel';
import lmnp from './lmnp';
import pinelDenormandie from './pinelDenormandie';
import per from './per';
import privateRental from './privateRental';

const index = {
    scpi,
    dismemberedScpi,
    lifeInsurance,
    pinel,
    pinelDenormandie,
    lmnp,
    per,
    privateRental,
};

export default index;
